var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSidbaricon1111(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3327 7.33333C10.3327 6.04467 9.28802 5 7.99935 5C6.71068 5 5.66602 6.04467 5.66602 7.33333C5.66602 8.622 6.71068 9.66667 7.99935 9.66667C9.28802 9.66667 10.3327 8.622 10.3327 7.33333Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3213 7.5666C10.536 7.63167 10.7637 7.66667 10.9995 7.66667C12.2882 7.66667 13.3329 6.622 13.3329 5.33333C13.3329 4.04467 12.2882 3 10.9995 3C9.7896 3 8.79473 3.92093 8.67773 5.10009",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.32115 5.10009C7.20415 3.92093 6.2093 3 4.99935 3C3.71068 3 2.66602 4.04467 2.66602 5.33333C2.66602 6.622 3.71068 7.66667 4.99935 7.66667C5.23522 7.66667 5.46292 7.63167 5.67753 7.5666",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 11C14.6667 9.15907 13.0251 7.66667 11 7.66667",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6673 13C11.6673 11.1591 10.0257 9.66667 8.00065 9.66667C5.9756 9.66667 4.33398 11.1591 4.33398 13",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.00065 7.66667C2.9756 7.66667 1.33398 9.15907 1.33398 11",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidbaricon1111);
export default __webpack_public_path__ + "static/media/sidbaricon1111.48d2820945a48d3d4ccbcc7f8c6b88b6.svg";
export { ForwardRef as ReactComponent };